// extracted by mini-css-extract-plugin
module.exports = {"search_input":"faq-module--search_input--195P8","search_container":"faq-module--search_container--3tRa7"};